
import React, { createRef, MouseEvent, useEffect, useState } from 'react';
import {Tree, Menu, SubMenuProps, TreeProps, MenuProps} from 'antd';
import {Scrollbars} from 'react-custom-scrollbars';

import {createFromIconfontCN} from '@ant-design/icons';
import {useHistory} from 'react-router-dom';
import { MenuModuleType, readMenuModule, readSiderWidth, updateMenuModule, writeSiderWidth } from '../../../../utils/storage';
import { publishMenuModule, SliderNavData, subscribeSliderNav, unsubscribeSliderNav } from '../../../../utils/ps';
import { MenuRecord } from '../../../../utils/storage';
import { findMenuItem, takeSliderNav } from './utils';

import './index.less'

const { SubMenu } = Menu;

const IconFont = createFromIconfontCN({
    scriptUrl: [
       '//at.alicdn.com/t/c/font_2343612_uey1i1zogf.js',
       '//at.alicdn.com/t/c/font_2343612_c7gxd0ggx57.js',
    ],
});

interface SliderNavProps {
  onResize: (value: { width: number })=> void
}

const SliderNav: React.FC<SliderNavProps> = ({ onResize })=> {

  const history = useHistory()

  const [width, setWidth] = useState(readSiderWidth())
  const [startX, setStartX] = useState(0)
  const [startWidth, setStartWidth] = useState(0)
  const [isDragging, setIsDragging] = useState(false)

  const [menus, setMenus] = useState<MenuRecord[]>([])

  const [openKey, setOpenKey] = useState<string>()
  const [selectedKey, setSelectedKey] = useState<string>()

  const navRef = createRef<HTMLDivElement>()

  const handleMouseDown = (e: MouseEvent) => {
    e.stopPropagation() 
    // 只处理鼠标左键事件
    if (e.button !== 0 || !navRef.current) {
      return
    }

    const { right } = navRef.current.getBoundingClientRect()

    // 限定拖拽区域为导航栏右侧边缘10像素范围内
    if (e.clientX >= right - 10) {
      setIsDragging(true)
      setStartX(e.clientX)
      setStartWidth(
        parseInt(window.getComputedStyle(navRef.current).width, 10)
      )
      document.addEventListener('mousemove', handleMouseMove)
      document.addEventListener('mouseup', handleMouseUp)
    }
  }

  const handleMouseMove = (e: globalThis.MouseEvent)=> { 
      if (!isDragging) {
        return
      }
  
      // 计算鼠标移动的距离
      const offset = e.clientX - startX;

      // 新的导航栏宽度
      const newWidth = startWidth + offset;
      
      // 防止导航栏过小或过大
      if (newWidth < 200 || newWidth > 500) {
        return
      }

      setWidth(newWidth)

      onResize({
        width: newWidth
      })
  }

  const handleMouseUp = ()=> {
      if (!isDragging) {
        return
      }

      writeSiderWidth(width)

      setIsDragging(false)
  
      document.removeEventListener('mousemove', handleMouseMove)
      document.removeEventListener('mouseup', handleMouseUp)

      onResize({ width })
  }

  const _handleSliderNavChange = async ({ menus, isInit }: SliderNavData)=> {

    const clone = await takeSliderNav(menus)
    
    setMenus(clone.menus)
    setOpenKey(clone.openKey)
    setSelectedKey(clone.selectedKey)

    const menuModule = readMenuModule() as MenuModuleType;

    let _levelTwoKey = clone.crumbs.levelTwoKey
    let _levelTwoUrl = clone.crumbs.levelTwoUrl
    let _levelTwoTitle = clone.crumbs.levelTwoTitle
    let _levelThreeKey = clone.crumbs.levelThreeKey
    let _levelThreeTitle = clone.crumbs.levelThreeTitle
    let _selectOpenMenuKey = clone.openKey
    let _selectMenuKey = clone.selectedKey
    let _selectMenuUrl = clone.selectedUrl
    let _dynamicMenuUrlParams = clone.dynamicUrlParams

    // 判断是否为页面刷新，路由到当前缓存的页面信息
    if (isInit) {
      _levelTwoKey = menuModule.levelTwoKey || '';
      _levelTwoUrl = menuModule.levelTwoUrl || '';
      _levelTwoTitle = menuModule.levelTwoTitle || '';
      _selectOpenMenuKey = menuModule.selectOpenMenuKey || '';
      _selectMenuKey = menuModule.selectMenuKey || '';
      _selectMenuUrl = menuModule.selectMenuUrl || '';
      _dynamicMenuUrlParams = menuModule.dynamicMenuUrlParams;
    } else {
        //存储菜单模块信息
        updateMenuModule({
          levelTwoKey: _levelTwoKey,
          levelTwoUrl: _levelTwoUrl,
          levelTwoTitle: _levelTwoTitle,
          levelThreeKey: _levelThreeKey,
          levelThreeTitle: _levelThreeTitle,
          selectOpenMenuKey: _selectOpenMenuKey,
          selectMenuUrl: _selectMenuUrl,
          selectMenuKey: _selectMenuKey,
          dynamicMenuUrlParams: _dynamicMenuUrlParams,
        }, false)
    }

    //发布 面包屑
    publishMenuModule()

    // 路由跳转
    if (_selectMenuUrl) {
      if (history.location.pathname === _selectMenuUrl) {
        history.push({
            pathname: "/emptyPage",
            state: {
              path: _selectMenuUrl,
              ..._dynamicMenuUrlParams
            }
        })
      } else {
          history.push({
            pathname: _selectMenuUrl,
            state: {..._dynamicMenuUrlParams}
          });
      }
      return
    }

    // 跳转默认组建(未配置菜单项)
    history.push("/noConfigPage");
  }

  const handleSelectMenuTitle: SubMenuProps['onTitleClick'] = ({ key }) => {

    const item = findMenuItem(key, menus)

    // 缓存菜单模块信息
    updateMenuModule({
      selectOpenMenuKey: key,
      levelTwoKey: key,
      levelTwoTitle: item?.title,
      levelTwoUrl: '',
    }, false)

    if (openKey !== key) {
      setOpenKey(key)
    }
  }

  const handleMenuItemClick: MenuProps['onClick'] = ({ key }) => {

    const item = findMenuItem(key, menus)

    setSelectedKey(key)
    
    // 缓存菜单模块信息
    updateMenuModule({
      levelTwoKey: key,
      levelTwoTitle: item?.title,
      levelTwoUrl: item?.url,
      levelThreeKey: "",
      levelThreeTitle: "",
      selectOpenMenuKey: key,
      selectMenuKey: key,
      selectMenuUrl: item?.url,
    });

    if (item?.url && item?.type != 'DYNAV') {
      history.push(item?.url);
    } else {
      history.push("/noprojectpage");
    }
  }

  const handleThreeMenuClick: TreeProps['onSelect'] = (_, { node }) => {
    const key = node.key as string

    const item = findMenuItem(key, menus)
    const levelTwoUrl = readMenuModule('levelTwoUrl')

    setSelectedKey(key as string)

    updateMenuModule({
      levelThreeKey: item?.key,
      levelThreeTitle: item?.title,
      selectMenuKey: item?.key,
      selectMenuUrl: item?.url,
      dynamicMenuUrlParams: {
        id: item?.key || '',
        code: item?.code || '',
      },
    })

    if (levelTwoUrl === history.location.pathname || item?.url === history.location.pathname) {
      history.push({
        pathname: "/emptyPage",
        state: {
          path: item?.url,
          id: item?.key,
          code: item?.code,
        }
      });
    } else {
      history.push({
        pathname: item?.url,
        state: {
          id: item?.key,
          code: item?.code
        }
      });
    }
  }

  const renderIcon = (icon: string | null)=> icon ? <IconFont type={icon}/> : null

  useEffect(()=> {
    subscribeSliderNav(_handleSliderNavChange)

    return ()=> {
      unsubscribeSliderNav()
    }
  }, [])

  return (
    <div className='slider-nav-wrapper'>
      <div className={'menu_bottom'} ref={navRef} onMouseDown={handleMouseDown}>
        <Scrollbars>
          <Menu
            openKeys={openKey ? [openKey] : undefined}
            mode="inline"
            theme="light"
            selectedKeys={selectedKey ? [selectedKey] : undefined}
          >
            {
              menus.map((item, index) => {
                if (item.children.length > 0 || item.type === 'DYNAV') {
                  return (
                    <SubMenu
                      key={item.key}
                      icon={renderIcon(item.iconName)}
                      title={item.title}
                      onTitleClick={handleSelectMenuTitle}
                    >
                        <Tree
                            showLine={{ showLeafIcon: false }}
                            onSelect={handleThreeMenuClick}
                            treeData={item.children}
                            selectedKeys={selectedKey ? [selectedKey] : undefined}
                            icon={renderIcon(item.iconName)}
                        />
                    </SubMenu>)
                }
                return (
                  <Menu.Item key={item.key} icon={renderIcon(item.iconName)} onClick={handleMenuItemClick}>{item.title}</Menu.Item>
                )
              })
            }
          </Menu>
        </Scrollbars>
      </div>
    </div>
  )
}

export default SliderNav